import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadLicensePlateStep2CustomerPopupBuyCar,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateStep2CustomerPopupBuyCar}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop="carleadCreation.form.step2.headline"
      headlineMobile="carleadCreation.form.step2.headline"
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
